import { getRouterConfig } from '@autobid/ui/utils/getRouterConfig'

export default getRouterConfig()
